module.exports = __webpack_public_path__ + "static/media/login.13f54019.png";